<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-row>
        <v-col cols="12" sm="6" md="6" lg="4" xl="4" v-for="index in 30" :key="index">
          <v-card>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        <v-row>
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Relatórios de atendimento
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4" xl="4" v-for="(item, index) in relatorios_atendimento" :key="index">
            <div class="item_lista" :class="item.link ? 'cursor-pointer' : ''" @click="gotoUrl(item.link)" v-ripple="item.link ? { class: `primary--text` } : false">
              <div class="text-h3 text-primary">
                <v-icon color="primary">{{item.icone}}</v-icon>
                {{item.nome}}
              </div>
              <div class="text text-gray mt-2">
                {{item.lead}}
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Relatórios comerciais
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4" xl="4" v-for="(item, index) in relatorios_comerciais" :key="index">
            <div class="item_lista" :class="item.link ? 'cursor-pointer' : ''" @click="gotoUrl(item.link)" v-ripple="item.link ? { class: `primary--text` } : false">
              <div class="text-h3 text-primary">
                <v-icon color="primary">{{item.icone}}</v-icon>
                {{item.nome}}
              </div>
              <div class="text text-gray mt-2">
                {{item.lead}}
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <div class="text-h2 text-primary mb-0">
              Relatórios operacionais
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4" xl="4" v-for="(item, index) in relatorios_operacionais" :key="index">
            <div class="item_lista" :class="item.link ? 'cursor-pointer' : ''" @click="gotoUrl(item.link)" v-ripple="item.link ? { class: `primary--text` } : false">
              <div class="text-h3 text-primary">
                <v-icon color="primary">{{item.icone}}</v-icon>
                {{item.nome}}
              </div>
              <div class="text text-gray mt-2">
                {{item.lead}}
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
// import Api from '@API'
export default {
  data () {
    return {
      loading: true,
      relatorios_atendimento: [
        {
          icone: 'savings',
          nome: 'Acompanhamento de Produtividade',
          lead: 'Este relatório tem como objetivo apresentar a produtividade dos clientes em um determinado período.',
          link: '/relatorios/produtividade'
        },
        {
          icone: 'description',
          nome: 'Faturas',
          link: '/relatorios/faturas',
          lead: 'Este relatório filtra as Usinas apresentando as Faturas de cada Usina, com as informações sobre o valor faturado, a energia consumida, compensada e injetada em um período de tempo.'
        },
        {
          icone: 'call',
          nome: 'Status dos Chamados',
          link: '/relatorios/chamados',
          lead: 'Esse relatório tem por objetivo apresentar os chamados abertos, e apresentar as informações sobre os que foram fechados, permaneceram abertos, e a quantidade total de acordo com cada cliente.'
        },
        {
          icone: 'credit_card',
          nome: 'Sistema de Crédito',
          lead: 'Esse relatório permite uma visualização detalhada da utilização de crédito das unidades consumidoras de acordo com o distribuidor, integrador ou cliente',
          link: '/relatorios/sistema-credito'
        },
        {
          icone: 'attach_money',
          nome: 'Retorno do Investimento',
          link: '/relatorios/retorno-investimento',
          lead: 'Esse relatório exibe o retorno de investimento das usinas selecionadas de acordo com o período escolhido. O retorno de investimento é agrupado por mês e ano.'
        },
        {
          icone: 'savings',
          nome: 'Acompanhamento Financeiro',
          lead: 'Este relatório tem como objetivo apresentar a situação financeira dos clientes em um determinado período.',
          link: '/relatorios/geral-cliente'
        }
      ],
      relatorios_comerciais: [
        {
          icone: 'monetization_on',
          nome: 'Resumo Comercial',
          link: '/relatorios/resumo-comercial',
          lead: 'O Resumo Comercial tem como finalidade entregar informações em relação à produtividade, isto é, os resultados. Assim, é possível verificar informações como quantidade de novos clientes, usinas instaladas, chamados realizados, acessos ao app, quanto foi investido e quanto foi economizado.'
        },
        {
          icone: 'visibility',
          link: '/relatorios/resumo-comercial-detalhado',
          nome: 'Visão Comercial Detalhada',
          lead: 'O relatório da Visão Comercial Detalhada abrange os resultados da empresa no período selecionado. Assim, exibindo informações de cada cliente em relação à data de ingresso, último acesso, usinas instaladas, chamados realizados, acessos ao app, total investido e total economizado.'
        }
      ],
      relatorios_operacionais: [
        {
          icone: 'group',
          nome: 'Clientes',
          link: '/relatorios/clientes',
          lead: 'Esse relatório tem como objetivo listar informações básicas dos clientes cadastrados selecionados e agrupá-los pelo integrador vinculado.'
        },
        {
          icone: 'battery_charging_full',
          nome: 'Inversores',
          link: '/relatorios/inversores',
          lead: 'Esse relatório tem como objetivo listar informações básicas dos Inversores cadastrados agrupados pelo integrador vinculado.'
        },
        {
          icone: 'apartment',
          nome: 'Unidades Consumidoras',
          link: '/relatorios/unidades',
          lead: 'Esse relatório tem como objetivo listar informações básicas das unidades consumidoras agrupadas pela concessionária vinculada.'
        },
        {
          icone: 'solar_power',
          nome: 'Usinas',
          link: '/relatorios/usinas',
          lead: 'Esse relatório tem como objetivo listar informações básicas das Usinas cadastradas.'
        },
        {
          icone: 'person_search',
          nome: 'Usuários',
          lead: 'Esse relatório tem como objetivo listar informações básicas dos Usuários cadastrados agrupados pelo distribuidor e integrador vinculado.',
          link: '/relatorios/usuarios'
        },
        {
          icone: 'account_balance',
          nome: 'Concessionárias',
          link: '/relatorios/concessionarias',
          lead: 'Esse relatório tem como objetivo listar informações básicas das concessionárias cadastradas selecionadas.'
        }
      ]
    }
  },
  methods: {
    gotoUrl (link) {
      this.$router.push({ path: link }).catch(() => {})
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    setTimeout(() => {
      if (!this.user.fk_int_id_integrador) {
        this.relatorios_operacionais.push({
          icone: 'badge',
          nome: 'Integradores',
          link: '/relatorios/integradores',
          lead: 'Esse relatório tem como objetivo listar as informações básicas dos integradores cadastrados selecionados.'
        })
      }
      this.loading = false
    }, 1500)
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_lista {
  border: 1px $primary solid;
  border-left-width: 10px;
  height: 100%;
  padding: 15px;
  .text-h3 {
    margin-bottom: 25px;
    position: relative;
    &:before {
      background: $primary;
      bottom: -10px;
      content: '';
      height: 1px;
      left: -15px;
      position: absolute;
      width: calc(100% + 30px);
    }
  }
  @media (max-width: 767px){}
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/Relatorios.vue